import { QueryFunctionContext, useQuery } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { legacy_import_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../query-function';
import {
  bankNotesKeys,
  parseBankNotesKey,
} from '../cache-keys/bankNotesKeys.tsx';

export function useBankNotes(
  applicationID: string | undefined,
  marketCountry: string | undefined
) {
  const api = useAPI();
  const cacheKey = bankNotesKeys.root({
    applicationID,
    marketCountry,
  });

  return useQuery(
    cacheKey,
    queryFunction(
      legacy_import_api.getBankNotes(api),
      ({
        queryKey,
      }: QueryFunctionContext<ReturnType<(typeof bankNotesKeys)['root']>>) => {
        const key = parseBankNotesKey(queryKey);
        return {
          applicationID: key.applicationID || '',
          marketCountry: key.marketCountry || '',
        };
      }
    ),
    {
      enabled: !!applicationID || !!marketCountry,
    }
  );
}
